<template>
<div class="container" id="login-page">
  <div class="login">
    <h1><span style="color: white">Touch Wall</span><br>
      Administration</h1>

      <input type="password" name="password" v-model="input.password" class="form-control" placeholder="Password" />
      <button type="submit" class="btn btn-primary" @click="login()">Login</button>
  </div>
</div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      input: {
        password: ''
      }
    }
  },
  methods: {
    str_rot13 (str) {
      return (str + '').replace(/[a-zA-Z]/gi, function (s) {
        return String.fromCharCode(s.charCodeAt(0) + (s.toLowerCase() < 'n' ? 13 : -13))
      })
    },

    login () {
      if (this.input.password !== '') {
        if (this.str_rot13(this.input.password) === this.$parent.mockAccount.password) {
          this.$emit('authenticated', true)
          this.$router.replace({ name: 'MarketForm' })
        } else {
          console.log('The password is incorrect')
        }
      } else {
        console.log('A password must be present')
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/login.vue